import { onClickOutside } from '@vueuse/core';
import Sortable from 'sortablejs';
/**
 * Vue directives setup
 */
export function initializeVueDirectives(app) {
    app.directive('datepicker', {
        beforeMount: function (el, binding, vnode) {
            let dateFormat = 'dd/mm/yy';
            let minDate = '';

            if ($(el).attr('format') === 'mdy') {
                dateFormat = 'mm/dd/yy';
            }

            if ($(el).attr('minDate') > 0) {
                minDate = '-' + $(el).attr('minDate');
            }

            $(el).datepicker({
                dateFormat: dateFormat,
                showOtherMonths: true,
                selectOtherMonths: true,
                minDate: minDate,
                onSelect: function (date) {
                    vnode.context[binding.expression] = date;
                },
            });
        },
        updated: function (el, binding) {
            $(el).datepicker('setDate', binding.value);
        },
    });

    app.directive('sortable', {
        beforeMount: function (el, binding, vnode) {
            const params = {
                onUpdate: function () {
                    vnode.context.$emit('sort', this.toArray());
                },
                handle: '.handle',
                dataIdAttr: 'colname',
            };

            el.sortable = Sortable.create(el, params);
        },

        updated: function () {
            return false;
        },
    });

    app.directive('sync', {
        updated: function (el, binding, vnode) {
            window.sellsyapp.set(vnode.context, binding.expression, vnode.componentInstance.$data);
        },
    });

    app.directive('click-outside', {
        mounted(el, binding, vnode) {
            onClickOutside(el, binding.value);
        },
    });

    /**
     * Directive to execute a function when hovering over a dom element
     * ex: <span v-hover="{over: onHoverFn, leave: onLeaveFn}"></span>
     *
     * Example of use CursorTooltip.vue
     */
    app.directive('hover', {
        beforeMount: function (el, binding, vNode) {
            const compName = vNode.context.name;

            // Provided expression must evaluate to an object.
            if (typeof binding.value !== 'object') {
                let warn = `[v-hover]: provided expression '${binding.expression}' is not an object, but it needs to be.`;
                if (compName) {
                    warn += `\nFound in component '${compName}'`;
                }
            }

            // Provided expression must have at least one "over" or "leave" properties
            if (!binding.value || (!binding.value?.over && !binding.value?.leave)) {
                let warn = `[v-hover]: object provided does not have 'over' or 'leave' properties. Needs at least one to be of use`;
                if (compName) {
                    warn += `\nFound in component '${compName}'`;
                }
            }

            el.__vHoverOver__ = binding.value?.over || (() => {});
            el.__vHoverLeave__ = binding.value?.leave || (() => {});

            // Add Event Listeners
            el.addEventListener('mouseover', el.__vHoverOver__);
            el.addEventListener('mouseleave', el.__vHoverLeave__);
        },
        unmounted: function (el) {
            // Remove Event Listeners
            el.removeEventListener('mouseover', el.__vHoverOver__);
            el.removeEventListener('mouseleave', el.__vHoverLeave__);
            delete el.__vHoverOver__;
            delete el.__vHoverLeave__;
        },
    });
}
